
export const lang = {
  title: 'VUE H5开发模板',
  tabbar: {
    home: '首页',
    list: '列表',
    member: '我的',
    demo: '示例',
  },
  language: {
    en: '英文',
    zh: '中文',
  },
  introduction: '一个快速开发vue3的移动端模板',
  home: {
    support: '支持',
    cssMultiLanguage: 'css图片多语言',
  },
  list: {
    details: '列表详情',
  },
  btn: {
    confirm: '确认',
    cancel: '取消',
  },
};
